import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 11,
  path: '/mechanism',
  component: Home,
  redirect: '/mechanism/mechanismAll/intermediary',
  name: 'mechanism',
  isHead: true,
  meta: {
    title: '服务机构管理',
    img: require('@/assets/img/bxfw.png')
  },
  children: [
    {
      path: 'mechanismAll',
      name: 'mechanismAll',
      component: () => import('@/views/mechanism/index'),
      meta: { title: '服务机构管理', close: false },
      children: [
        {
          path: 'intermediary',
          name: 'intermediary',
          component: () => import('@/views/mechanism/intermediary/index'),
          meta: { title: '机构管理', close: false,},
        }
      ],
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/intermediary.js